export const LeadsTypes = Object.freeze({
  active: 'active',
  completed: 'completed',
  new: 'new',
  requireAction: 'require-action',
});
